import { InputAdornment, Button } from "@mui/material";
import { ChangeEvent } from "react";

import { formatCurrencyToShow } from "../../helpers/currency";
import InputGeneric from "../InputGeneric";

export type PlanServerFeeTier = {
    id: string;
    trips_quantity: string | number;
    fee: string;
};

export function createPlanServerFeeId(): string {
    return `fee-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

type Props = {
    tier: PlanServerFeeTier;
    onChangeTripsQuantity: (id: string, value: string) => void;
    onChangeFee: (id: string, value: string) => void;
    onRemove: (id: string) => void;
};

function PlanServerFeeRow({
    tier,
    onChangeTripsQuantity,
    onChangeFee,
    onRemove,
}: Props) {
    return (
        <div className="inputsContainer serverFeeRow">
            <InputGeneric
                size="small"
                className="smallInput"
                type="number"
                label="Quantidade de viagens"
                value={tier.trips_quantity}
                inputProps={{ min: 0 }}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    onChangeTripsQuantity(tier.id, event.target.value);
                }}
            />
            <InputGeneric
                size="small"
                className="smallInput"
                label="Taxa a ser cobrada"
                value={tier.fee}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                    onChangeFee(
                        tier.id,
                        formatCurrencyToShow(event.target.value, true)
                    );
                }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">R$</InputAdornment>
                    ),
                }}
            />
            <Button
                type="button"
                color="error"
                variant="outlined"
                size="small"
                onClick={() => {
                    onRemove(tier.id);
                }}
            >
                Remover
            </Button>
        </div>
    );
}

export default PlanServerFeeRow;
